import hhkjsq from '@/common/hhkjsq.js'
const {hosts} = hhkjsq
export default {
  GET_PAGE_INFO: function (id) {
    return `${hosts.common}/Html/Live/Infos/${id}.json`
  },
  GET_ALL_COMMENT_LIST: hosts.discuss1 + '/API/AComment/CommentList',
  GET_ELITE_COMMENT_LIST: hosts.discuss1 + '/API/AComment/CommentTopList',
  GET_TOP_NUM_COMMENT_LIST: hosts.discuss1 + '/API/AComment/GetCommentListForTopNum',
  PUB_COMMENT: hosts.discuss1 + '/API/AComment/PubComment',
  POST_COMMENT: hosts.discuss1 + '/API/AComment/PostComment',
  POST_PRAISE: hosts.userop + '/API/APraise/PostPraise',
  PUB_PRAISE: hosts.userop + '/API/APraise/PubPraise',
  DEL_PRAISE_INFO: hosts.userop + '/API/APraise/DelPraiseInfo',
  PRAISE_LIST: hosts.userop + '/API/APraise/PraiseInfo',
  GET_POST_BY_ID: hosts.mtalksvcv2 + '/api/info/getById',
  GET_HEAD_PIC: function (id) {
    return `${hosts.usertxcdn}/info/getheadpic?id=${id}`
  },
  GET_USER_HOME: function (name) {
    return `${hosts.main}/userweb/${name}`
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js